import { ReactNode } from 'react';

import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

export const DefaultValueSection = ({ children }: { children: ReactNode }) => {
  const { t } = useScopedTranslate(locale);

  return (
    <Stack space={2}>
      <Text font="semibold14" color="textSecondary" text={t('defaultValue')} />
      {children}
    </Stack>
  );
};

const locale = {
  en: {
    defaultValue: 'Default value',
  },
};
